enum ExtractColumns {
  Time = 0,
  Airport,
  Metrics,
  None,
}

export default ExtractColumns;
